import React, { useState, useEffect, useRef } from 'react'
import { AreaPicker, Header, Marquee, ScrollList, RechargeEntry,  UserLogin, Logo, FooterCopy, LogoMenu } from '@/components'
import api from '@/api'
import { history, getUser, isUserLogin } from '@/util'
import { Form, Input, Button, TextArea, Switch, Swiper } from 'antd-mobile'
import queryString from 'query-string'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import { LocalKeyMap } from '@/local';

import styles from './index.module.scss'

const HomeIndex = props => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const [homeData, setHomeData] = useState({})
  const [navList, setNavList] = useState([])
  const [nav, setNav] = useState('')
  const [hasMore, setHasMore] = useState(false)
  const [meta, setMeta] = useState({ last_page: 1, current_page: 0 })
  const [isLoading, setIsLoading] = useState(false)
  const [itemList, setList] = useState([{},{},{}])
  const { user } = getUser()

  const getData = () => {
    if (isLoading) return
    const payLoad = {
      page: meta.current_page + 1,
      per_page: 20,
      category_id: nav,
    }
    setIsLoading(true)
    api.post('/index/goods-index', payLoad, { showLoading: true }).then(res => {
      setIsLoading(false)
      if (res?.error) return
      setMeta(res?.meta || {})
      payLoad.page === 1 ? setList([...res?.data]) : setList([...itemList, ...res?.data])
      setHasMore(res?.meta?.current_page < res?.meta?.last_page)
    })
  }

  const getTab = () => {
    api.post('/index/index').then(res => {
      if (res?.error) return
      console.log(res)
      setHomeData(res)
      setNavList(res?.goods_tabs || [])
      setNav(res?.goods_tabs[0].value)
    })
  }

  // {{web_api_url}}/

  const initData = () => {
    setMeta(Object.assign(meta, { last_page: 1, current_page: 0 }))
    // setIsbBatching(false)
  }

  const switchTab = val => {
    if (nav === val) return
    initData()
    setNav(val)
  }

  useEffect(() => {
    getTab()
  }, [])

  useEffect(() => {
    if (nav) getData()
  }, [nav])

  return (
    <div className={styles.page}>
      <Header
          backIcon={<Logo></Logo>}
          render={
            <div className={styles.headerContent}>
              <RechargeEntry></RechargeEntry>
            </div>
          }
          right={
            <UserLogin></UserLogin>
          }
          isNotBackPage={true}
          onLeftTap={()=>{
            navigate('?tab=group', {replace: true})
          }}
          // backIcon={<></>}
          // render={
          //   <div className={styles.headerContent}>
          //     <LogoMenu></LogoMenu>
          //     <RechargeEntry></RechargeEntry>
          //   </div>
          // }
          // right={
          //   <UserLogin></UserLogin>
          // }
          extraClass={styles.indexHeader}
          immersed
          isFixed
          isPlaceholder
          isPullShowWhiteHeader={false}
          mode="light"
        // ref={headerRef}
          // style={headerStyle}
          // title={t(LocalKeyMap['myIndex.title'])}
      />
      <div className={styles.homeContent}>
        <div className={styles.bannerBox}>
          <Swiper autoplay loop>
            {
              homeData?.wap_top_banner?.map((item, index) => (
                <Swiper.Item key={index}>
                  <div
                    key={index}
                    className={styles.content}
                    onClick={()=>{
                      const isHttpUrl = /^http[s]?:/.test(item.link)
                      if (isHttpUrl) {
                        window.open(item.link, '_blank');
                      } else {
                        navigate(item.link)
                      }
                    }}
                    // style={{ background: color }}
                    // onClick={() => {
                    //   navigate(`/universeBox/simpleDetail?id${item.goods_id}`)
                    // }}
                  >
                    <img src={item?.image?.thumb_m} alt="" />
                  </div>
                </Swiper.Item>
              ))
            }
          </Swiper>
        </div>
        {
          homeData?.notice_list?.length > 0 &&
          <div className={styles.marqueeWrap}>
            <div className={styles.noticeIcon}></div>
            <div className={styles.marqueeBox}>
              <Marquee
                content={
                <>
                  {homeData?.notice_list?.map((item, key) => {
                    return (
                      <span key={key}>{item}</span>
                    )
                  })}
                </>
              }
                speed={60}
            ></Marquee>
            </div>
          </div>
        }
        <div className={styles.cardsNavWrap}>
          <div className={styles.cardsNav}>
          <div className={styles.cardsNavBox}>
              {
                navList.map((item, index)=>{
                  return <div
                    className={`${styles.navItem} ${item.value === nav ? styles.active : ''}`}
                    key={index}
                    onClick={()=>{
                      switchTab(item.value)
                    }}
                    >
                    {item.name}
                  </div>
                })
              }
            </div>
          </div>
        </div>
        <div className={styles.cardsList}>
          <ScrollList
              emptyProps={{
                desc: t(LocalKeyMap['emptyPage.noDate']),
                // style: { paddingTop: 100 },
              }}
              infiniteScrollProps={{
                hasMore: hasMore,
                loadMore: getData,
              }}
              isLoading={isLoading}
              // listClassName="order-list-ubox-content"
              listData={itemList}
              theme="light">
            {
              itemList.map((item, key)=>{
                return <div className={styles.cardsItem}
                  key={key}
                  onClick={() => {
                    navigate(`/universeBox/simpleDetail?id=${item?.goods_id}`)
                  }}>
                  <div className={styles.tags}>
                    {
                      (item?.tags ?? []).length > 0 &&
                      item?.tags?.map((item, index)=>{
                        return <span key={index}>{item?.name}</span>
                      })
                    }
                  </div>
                  <div className={`${styles.pic} ${item?.status === 'sellout' ? styles.sellout : ''}`}>
                    <img src={item?.cover_image?.thumb_m} alt={item?.title} />
                  </div>
                  <div className={styles.progress}>
                    <div className={styles.progressBase}></div>
                    <div className={styles.progressBar} style={{width: `${100-item?.stock_percentage}%`}}></div>
                  </div>
                  <div className={styles.meta}>
                    <div className={styles.price}>
                      <span className={styles.iconGold}></span>
                      <strong className={styles.num}>
                        {item?.score}<span className={styles.unit}>pt</span>
                      </strong>
                      <strong className={styles.round}>
                        /
                        {
                          t(LocalKeyMap['home.round'])
                        }
                      </strong>
                    </div>
                    {
                       item?.status === 'sellout' ?
                        <div className={styles.sellout}>
                          {t(LocalKeyMap['soldOut'])}
                        </div>
                       :
                        <div className={styles.quantity}>
                          {
                            t(LocalKeyMap['home.residue'])
                          }
                          <strong>{item?.available_stock}/{item?.total_stock}</strong>
                        </div>
                    }
                  </div>
                </div>
              })
            }
          </ScrollList>
        </div>
      </div>
      <FooterCopy></FooterCopy>
    </div>
  )
}

export default HomeIndex
